
/**
 * 公共方法--下拉值
 */
export default {
    jobApplStatusMap: [
        {value: 'TEACHER_REVIEWING', label: 'Teacher Reviews'},
        {value: 'REJECTED', label: 'Teacher Rejected'},
        {value: 'PEND_IP_RECEIPT', label: 'Pend IP Receipt'},
        {value: 'IP_PROCESSING', label: 'IP Processing'},
        {value: 'REQUEST_DOCUMENT', label: 'IP Request More Info'},
        {value: 'DOCUMENT_ATTACHED', label: 'Student Updated Info'},
        {value: 'DECLINED', label: 'IP No Consider'},
        {value: 'OFFER', label: 'IP Made Offer'},
        {value: 'OFFER_DECLINED', label: 'Offer Rejected'},
        {value: 'IN_PROGRESS', label: 'Offer Accepted'},
        {value: 'SPECIAL_ARRANGEMENT', label: 'Special Arrangement'},
        {value: 'DRAFT', label: 'Draft'},
        { value:"WITHDRAWN", label:"Job Post Withdrawn" },
        { value:"STUDENT_WITHDRAWN", label:"Withdrawn" },
    ],
    wpaFormStatusMap: [
        {value: 'DRAFT', label: 'Draft'},
        {value: 'PENDING_SEND', label: 'Pending Send'},
        {value: 'RETURNED_TO_STUDENT', label: ' Returned to Student'},
        {value: 'SENT_TO_IS', label: 'Sent to IS'},
        {value: 'PENDING_REVIEW', label: ' Pending Review'},
        {value: 'REJECTED', label: ' Rejected'},
        { value:"ACCEPTED", label:"Accepted" },
        { value:"ACCEPTED_OFFLINE", label:"Accepted (Offline)" },
        { value:"TERMINATED", label:" Terminated" },
    ],
    KeyDocumentStatusMap: [
        {value: 'DRAFT', label: 'Draft'},
        { value:"SUBMITTED", label:"Submitted" },
    ],
    assignmentStatusMap: [
        {value: 'BLANK', label: 'Blank'},
        {value: 'WIP', label: 'WIP'},
        { value:"SUBMITTED", label:"Submitted" },
        { value:"SUBMITTED_LATE", label:"Submitted (Late)" },
        { value:"OVERDUE", label:"Overdue" },
    ],
    studentModuleStatusMap: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'HOLD_WIL', label: 'Hold WIL' },
        { value: "DROPPED", label:"Dropped" },
        { value: 'COMPLETED', label: 'Completed' },
    ],
    recipientMap: [
        { value: "GENERAL", label: "General" },
        { value: "STUDENT", label: "Student" },
        { value: "ACADEMIC", label: "Academic" },
        { value: "INDUSTRY_PARTNER", label: "Industry Partner" },
    ],
    recipientAdminMap: [
        { value: "", label: "" },
        { value: "GENERAL", label: "General" },
        { value: "STUDENT", label: "Student" },
        { value: "ACADEMIC", label: "Academic" },
        { value: "INDUSTRY_PARTNER", label: "Industry Partner" },
        { value: "CENTER_EMAIL", label: "Center Email" },
        { value: "LITE_ADMIN", label: "Lite Admin" },
        { value: "SUPER_SYSTEM_ADMIN", label: "Super Admin" },
    ],
    inds: [
        { value: "Y", label: "是" },
        { value: "N", label: "否" },
    ],
    indsTransalation: [
        { value: "Y", SC: "是", TC: "是", EN: "Yes" },
        { value: "N", SC: "否", TC: "是", EN: "No" },
    ],
    activeTransalation: [
        { value: "Y", SC: "激活", TC: "激活", EN: "Active" },
        { value: "N", SC: "未激活", TC: "未激活", EN: "Inactive" },
    ],
    entryDate: [
        { value: "1", SC: "1", TC: "1", EN: "1" },
        { value: "2", SC: "2", TC: "2", EN: "2" },
        { value: "3", SC: "3", TC: "3", EN: "3" },
        { value: "4", SC: "4", TC: "4", EN: "4" },
    ],
    emailActiveTransalation: [
        { value: "D", SC: "草稿", TC: "草稿", EN: "Draft" },
        { value: "Y", SC: "激活", TC: "激活", EN: "Active" },
        { value: "N", SC: "未激活", TC: "未激活", EN: "Inactive" },
    ],
    editionMap: [
        { value: "師傅版", label: "師傅版" },
        { value: "工場版", label: "工場版" },
    ],
    maritalMap: [
        { value: "Y", label: "已婚" },
        { value: "N", label: "未婚" },
    ],
    activeMap: [
        { value: "Y", label: "Active" },
        { value: "N", label: "Inactive" },
    ],
    teacherCategoryMap: [
        { value: "MC", label: "Module Convener" },
        { value: "AS", label: "Academic Supervior" },
        { value: "PL", label: "Programme Leader" },
    ],
    activeMapTransalation: [
        { value: "Y", SC: "激活", TC: "激活", EN: "Yes"  },
        { value: "N", SC: "冻结", TC: "凍結", EN: "No"  },
    ],
    funcType:[
        { value: "Operation", label: "Operation" },
        { value: "Enquiry", label: "Enquiry" },
    ],
    scopeApplication: [
        { value: "師傅版", label: "師傅版" },
        { value: "工場版", label: "工場版" },
    ],
    funcTypeMap: [
        { value: "MENU", SC: "一级模块", TC: "一級模塊", EN: "Menu" },
        { value: "FUNC", SC: "二级模块", TC: "二級模塊", EN: "Function" },
        { value: "SUBFUNC", SC: "三级模块", TC: "三級模塊", EN: "Subfunction" },
    ],
    operationTypeList: [
        { value: "ADD", label: "ADD" },
        { value: "MODIFY", label: "MODIFY" },
        { value: "DELETE", label: "DELETE" },
        { value: "VISIT", label: "VISIT" },
        { value: "LOGIN", label: "LOGIN" },
        { value: "LOGINOUT", label: "LOGINOUT" }
    ],
    resultTypeList: [
        { value: "SUCCESS", label: "SUCCESS" },
        { value: "FAIL", label: "FAIL" },
    ],
    apiSendingMethodList: [
        { value: "POST", label: "POST" },
        { value: "GET", label: "GET" },
        { value: "PUT", label: "PUT" },
        { value: "DELETE", label: "DELETE" },
    ],
    requestStatus:[
        { value: "200", label: "200" },
        { value: "201", label: "<> 200" },
    ],
    jobStatusMap: [
        { value: "Y", SC: "正常", TC: "正常", EN: "Normal" },
        { value: "N", SC: "暂停", TC: "暫停", EN: "Stop" },
    ],
    concurrentMap: [
        { value: "Y", SC: "允许", TC: "允許", EN: "Permit" },
        { value: "N", SC: "禁止", TC: "禁止", EN: "Forbidden" },
    ],
    executeStatusMap: [
        { value: "1", SC: "成功", TC: "成功", EN: "Succees" },
        { value: "2", SC: "失败", TC: "失敗", EN: "Fail" },
    ],
    hiddenOrDisplayMap: [
        { value: "Y", label: "显示" },
        { value: "N", label: "隐藏" },
    ],
    pictureCodeMap: [
        { value: "PROMOTION_POSTER", label: "推广海报" },
        { value: "HOME_ROTATION_CHART", label: "首页轮播图" },
        { value: "PIC_NAV", label: "图片导航-横图" },
        { value: "PIC_NAV_L", label: "图片导航-竖图" },
        { value: "PIC_NAV_BOT", label: "服务保障" },
        { value: "PRODUCT_NAV", label: "热卖专区" },
        { value: "BRAND_STORY", label: "品牌故事" },
    ],
    videoCategoryMap: [
        { value: "HOME_VIDEO", label: "首页视频" },
    ],
    productStatusMap: [
        { value: "Y", label: "已上架" },
        { value: "N", label: "未上架" },
    ],
    newsManagementMap:[
        {value:"Y",label:"是"},
        {value:"N",label:"否"},
    ],
    inventoryCountTypeMap: [
        { value: "BY_ORDER", label: "下单减库存" },
        { value: "BY_PAY", label: "付款减库存" },
    ],
    orderStatusMap: [
        { value: "UNPAID", label: "待支付" },
        { value: "UNSHIPPED", label: "待发货" },
        { value: "UNRECEIVED", label: "待收货" },
        { value: "COMPLETED", label: "已完成" },
        { value: "CANCELLED", label: "已取消" },
        { value: "RETURNING", label: "退货中" },
        { value: "SUCCESS", label: "退货成功" },
        { value: "FAIL", label: "退货失败" },
    ],
    orderStatusProcessMap: [
        { value: "UNPAID", label: 0 },
        { value: "UNSHIPPED", label: 1 },
        { value: "UNRECEIVED", label: 2 },
        { value: "COMPLETED", label: 3 },
    ],
    returnExchangeTypeMap: [
        { value: "REFUND", label: "仅退款" },
        { value: "RETURN_AND_REFUND", label: "退货退款" },
        /* { value: "EXCHANGE", label: "换货" }, */
    ],
    processStatusMap: [
        { value: "PENDING_REVIEW", label: "申请中" },
        { value: "APPL_REJECT", label: "拒绝申请" },
        { value: "RETURN_UNSHIPPED", label: "待发货" },
        { value: "RETURN_UNRECEIVED", label: "待收货" },
        { value: "RETURN_UNREFUNDED", label: "待退款" },
        { value: "RETURN_REFUNDED", label: "已退款" },
        { value: "REFUND_REJECT", label: "拒绝退款" },
    ],
    buyersReceivingStatusMap: [
        { value: "RECEIVED", label: "已收到货" },
        { value: "UNRECEIVED", label: "未收到货" },
    ],
    payModeMap: [
        { value: "WECHAT", label: "微信" },
        { value: "INTEGRAL", label: "积分" },
        { value: "OTHER", label: "其它" },
        { value: "WALLET", label: "钱包" },
        { value: "COMBINED", label: "组合" },
    ],
    rewardMap: [
        { value: "CONSUMPTION", label: "消费奖励" },
        { value: "REGISTER", label: "注册奖励" },
        { value: "TEAM", label: "团队奖励" },
        { value: "AUTO_OR_MANUAL_AUDIT", label: "审核方式" },
        { value: "REWARD_WITHDRAW", label: "奖励提现" },
    ],
    auditStatusMap: [
        { value: "APPROVE", label: "同意" },
        { value: "REJECT", label: "拒绝" },
    ],
    balanceWithdraw: [
        { value: "APPROVE", label: "同意" },
        { value: "REJECT", label: "拒绝" },
        { value: "UNCHECKED",label:"未审核"}
    ],
    businessTypeMap:[
        {value:"CONSUMPTION_REWARD",label:"消费奖励"},
        {value:"REGISTER_REWARD",label:"注册奖励"},
        {value:"TEAM_REWARD",label:"团队奖励"},
        {value:"WITHDRAWAL",label:"申请提现"},
        {value:"WITHDRAWAL_APPROVE",label:"提现成功"},
        {value:"WITHDRAWAL_REJECT",label:"提现拒绝"}
    ],
    walletMap:[
        {value:"PAYMENT",label:"支付"},
        {value:"REFUND",label:"退款"},
        {value:"TOPUP",label:"充值"},
        {value:"WITHDRAWAL",label:"申请提现"},
        {value:"WITHDRAWAL_APPROVE",label:"提现成功"},
        {value:"WITHDRAWAL_REJECT",label:"提现拒绝"},
        {value:"RECHARGE",label:"充值"}
    ],
    withdrawalType:[
        {label:"微信",value:"WECHAT"},
        {label:"支付宝",value:"ALIPAY"},
        {label:"银行卡",value:"BANK_CARD"}
    ],
    paymentStatusMap:[
        {value:"SUCCESS",label:"已打款"},
        {value:"NOTPAY",label:"未打款"},
        {value:"CLOSED",label:"已关闭"},
    ],
    maintenanceItemMap:[
        {value:"PAYMENT",label:"改圈號"},
        {value:"REFUND",label:"刻字"},
        {value:"TOPUP",label:"改长度"},
        {value:"WITHDRAWAL",label:"加/換配件/部件"},
        {value:"WITHDRAWAL_APPROVE",label:"焊接"},
        {value:"WITHDRAWAL_REJECT",label:"翻新"},
        {value:"RECHARGE",label:"配原料"},
        {value:"RECHARGE",label:"其他維修項目"}
    ],
    gNumMap:[
        {value:"PAYMENT",label:"G156"},
        {value:"REFUND",label:"G157"},
        {value:"TOPUP",label:"G158"},
    ],
    letterNumMap:[
        {value:"A", label:"01"},
        {value:"B", label:"02"},
        {value:"C", label:"03"},
        {value:"D", label:"04"},
        {value:"E", label:"05"},
        {value:"F", label:"06"},
        {value:"G", label:"07"},
        {value:"H", label:"08"},
        {value:"I", label:"09"},
        {value:"J", label:"10"},
        {value:"K", label:"11"},
        {value:"L", label:"12"},
        {value:"M", label:"13"},
        {value:"N", label:"14"},
        {value:"O", label:"15"},
        {value:"P", label:"16"},
        {value:"Q", label:"17"},
        {value:"R", label:"18"},
        {value:"S", label:"19"},
        {value:"T", label:"20"},
        {value:"U", label:"21"},
        {value:"V", label:"22"},
        {value:"W", label:"23"},
        {value:"X", label:"24"},
        {value:"Y", label:"25"},
        {value:"Z", label:"26"}
    ],
    userAccountManagementStudent:[
        {value:"1",label:"Active"},
        {value:"2",label:"Inactive"},
    ],
    loginAccount:[
        {value:"1",label:"Admin"},
    ],
    programmeReviewStatus:[
        {value:"1",label:"Reviewed"},
    ],
    activeStatusMap:[
        { value: "Y", label: "Active" },
        { value: "N", label: "Inactive" },
    ],
    wpaTemplate:[
        {value:"1",label:"WPA_Template_1"},
        {value:"2",label:"WPA_Template_2"},
    ],
    userEvaluationFrom:[
        {value:"1",label:"FreeText"},
        {value:"2",label:"Checkbox"},
        {value:"3",label:"Radion Button"},
        {value:"4",label:"Mark 1-5"},
    ],
    indStatusMap: [
        { value:"Y", label:"Yes" },
        { value:"N", label:"No" },
    ],
    deptMap:[
        { value:"1", label:"Finance" },
        { value:"2", label:"Marketing " },
        { value:"3", label:"Research and Development" },
        { value:"4", label:"Procurement " },
    ],
    userTypeMap: [
        { value:"ADMIN", label:"Admin" },
        { value:"ACADEMIC", label:"Academic" },
        { value:"PARTNER", label:"Partner" },
        { value:"STUDENT", label:"Student" },
    ],
    userTypeAddMap: [
        { value:"ADMIN", label:"Admin" },
    ],
    userTypeLiteAdminMap: [
        { value:"LITE_ADMIN", label:"Lite Admin" },
    ],
    templateType:[
        {value:"EMAIL",label:"Email Notification"},
    ],
    jobPostStatusMap: [
        { value:"DRAFT", label:"Draft" },
        { value:"SUBMITTED", label:"THEi Reviewing" },
        { value:"ACTIVE", label:"Active" },
        { value:"REJECTED", label:"THEi Rejected" },
        { value:"EXPIRED", label:"Expired" },
        { value:"WITHDRAWN", label:"Withdrawn" },
    ],
    interviewStatusMap: [
        { value:"IP_SCHEDULING_INTERVIEW", label:"IP Scheduling Interview" },
        { value:"STUDENT_NO_SHOW", label:"Interview - Student No Show" },
        { value:"IP_WITHDRAW", label:"Interview - IP Withdraw" },
        { value:"INTERVIEWED", label:"Interviewed" },
        { value:"N/A", label:"N/A" },
    ],
    attentionNeededMap: [
        { value:"NEW_INFO", label:"New Info!" },
    ],
    turnitinErrorCodeMap: [
        { value:"UNSUPPORTED_FILETYPE", label:"The uploaded file type is not supported." },
        { value:"PROCESSING_ERROR", label:"An unspecified error occurred while processing the submission." },
        { value:"CANNOT_EXTRACT_TEXT", label:"The submission does not contain text to generate a Similarity Report, or the word count of the submission is 0." },
        { value:"TOO_LITTLE_TEXT", label:"The submission does not have enough text to generate a Similarity Report. A submission must contain at least 20 words." },
        { value:"TOO_MUCH_TEXT", label:"The submission contains too much text to generate a Similarity Report. After the text is converted to UTF-8, the submission must contain less than 2MB of text." },
        { value:"TOO_MANY_PAGES", label:"The submission has too many pages to generate a Similarity Report. A submission cannot contain more than 800 pages." },
        { value:"FILE_LOCKED", label:"The uploaded file is password-protected and requires a password to be opened." },
        { value:"CORRUPT_FILE", label:"The uploaded file appears to be corrupted." },
    ]
}